import React, { useEffect } from "react";
import { Button } from "@material-ui/core";
import { Grid } from "@material-ui/core";
// import { Input, InputAdornment } from "@material-ui/core";
// import EmailIcon from "@material-ui/icons/Email";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
// import LockIcon from "@material-ui/icons/Lock";
//import TextField from "@material-ui/core/TextField";

import IsLoadingHOC from "../../hooks/IsLoading/IsLoadingHOC";
import { auth, provider } from "../../firebase/firebase";
import classes from "./Login.module.css";
import logo from "../../img/crit_fail_logo.png";
import FireflyAnimation from "../../hooks/Animations/FireflyAnimation";
import CampfireAnimation from "../../hooks/Animations/CampfireAnimation";
import ConfirmDialog from "../../hooks/Dialogs/ConfirmDialog";

function Login(props) {
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const { setLoading } = props;
  //const [inputValue, setInputValue] = useState(null);


const [open, setOpen] = React.useState(false);
const confirmOpen = open;
 const toggleModal = () => {
    setOpen(!open);
  };

  useEffect(() => {
    setLoading(false);
  });

  const signIn = () => {
    
    // Google Login
    setLoading(true);
    auth.signInWithPopup(provider).catch((error) => alert(error.message));
  };


  // let googleSignIn = (
  //   <span className={classes.wrapper}>
  //     <TextField
  //     label={"Enter password"}
  //     color="primary"
  //     InputLabelProps={{
  //       shrink: true,
  //     }}
  //       value={inputValue}
  //       onChange={(e) => {
  //         setInputValue(e.target.value);
  //       }}
  //     />
  //   </span>
  // );

  // if (inputValue === "rayoffrost") {
  // let  googleSignIn = (
  //     <span className={classes.wrapper}>
  //       <Button
  //         onClick={signIn}
  //         className={classes.TextField__button}
  //         startIcon={<VpnKeyIcon style={{ color: "#FFFF" }} />}
  //       >
      
  //         Enter with Google
  //       </Button>
  //     </span>
  //   );

  // }

  return (
    <div className={classes.login}>
      <FireflyAnimation></FireflyAnimation>

      <Grid
        container
        spacing={1}
        direction="column"
        alignItems="center"
        justify="center"
      >
        <Grid item xl={12} xs={12}>
          <div>
            <img src={logo} alt="welcome!" />
          </div>
        </Grid>
        <Grid item xl={12} xs={12}>
          <div>
            <CampfireAnimation></CampfireAnimation>
          </div>
          <div className={classes.bannerText}>
            <h1>Where your characters live.</h1>
          </div>
        </Grid>

        {/* <div className={classes.gradient__box}> */}
        <Grid item xs={12}>
          <div className={classes.wrapper}> 
        <Button onClick={toggleModal} 
        className={classes.TextField__button}
          startIcon={<VpnKeyIcon style={{ color: "#FFFF" }} />}>
            Enter with Google
                      <ConfirmDialog
                        title="Critfail Disclaimer"
                        open={confirmOpen}
                        toggleModal={toggleModal}
                        onConfirm={signIn}
                      >
                         <h2>By signing in you agree to the following disclaimer</h2>
                        
                         <p>If you require any more information or have any questions about our site's terms, please feel free to contact us by email at developer@critfail.in.</p>
<h2>Disclaimer for Critfail</h2>
<p>All the information on this website - https://critfail.in/ - is published in good faith and for general information purpose only. Critfail does not make any warranties about the completeness, reliability and accuracy of this information. Any action you take upon the information you find on this website (Critfail), is strictly at your own risk. Critfail will not be liable for any losses and/or damages in connection with the use of our website.</p>
<p>Please do not use this site for anything other than the intended use case of 'rolling dice with friends whilst remote'. We ask that you please do not upload any data in the form of personal information or media outside this use case because we cannot guarantee its security. This is a free service designed purely for remote dice rolling and as such we have not added heightened security or data encryption to this site. Critfail will not be liable for any losses and/or damages in connection with the loss of any personal data or media uploaded to our website.</p>
<p>From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone 'bad'.</p>
<p>Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their "Terms of Service" before engaging in any business or uploading any information.</p>
<h2>Consent</h2>
<p>By using our website, you hereby consent to our disclaimer and agree to its terms.</p>
<h2>Update</h2>
<p>Should we update, amend or make any changes to this document, those changes will be prominently posted here.</p>

                         
                         
                    </ConfirmDialog>
                      
                    </Button>
                    
                    </div>

          {/* {googleSignIn} */}
       
        </Grid>
  
        
        <FireflyAnimation>

          
        </FireflyAnimation>

        {/* </div> */}
      </Grid>
      <Grid item xs={12}>
      <div className={classes.thanks}>
          <p>Special thanks to <a href="https://codepen.io/mikegolus">Mike Golus</a> and <a href="https://codepen.io/short">Jake Hamilton</a> for their CSS animation wizardry</p>
          </div>
      </Grid>
    </div>
  );
}

export default IsLoadingHOC(Login, "Loading...");

// OLD CODE may be useful for when we do more advanced signup

// const signInWithEmail = () => {
//   // Email Login
//   auth
//     .signInWithEmailAndPassword(email, password)
//     .catch((error) => alert(error.message));
// };

// const signUpWithEmail = () => {
//   // Email SignUp
//   auth
//     .createUserWithEmailAndPassword(email, password)
//     .catch((error) => alert(error.message));
// };

// return (
// <div className={classes.login}>

//     <form>
//       <div>
//         <img
//           src={logo}
//           className={classes.login__img}
//           alt="Logo"
//           loading="lazy"
//         />
//       </div>

//       <div className={classes.form__group}>
//         <div className={classes.login__form__social__icon}>
// <Button
//   onClick={signIn}
//   className={classes.social__icon__button}
//   startIcon={<EmailIcon style={{ color: "#B9BBBE" }} />}
// >
//   Log in with Google
// </Button>
//         </div>
/*
           <div className={classes.login__form__seperator}>
            <b className={classes.login__form__seperator__b}>or</b>
          </div>
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              name="email"
              placeholder="E-mail Address"
              className={classes.login__form__input}
              startAdornment={
                <InputAdornment position="start">
                  <EmailIcon style={{ color: "#2E3036" }} />
                </InputAdornment>
              }
            />
          </div>
          <div className={classes.form__group}>
            <Input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              name="psw"
              placeholder="Password"
              className={classes.login__form__input}
              startAdornment={
                <InputAdornment position="start">
                  <LockIcon style={{ color: "#2E3036" }} />
                </InputAdornment>
              }
            />
          </div>
          <div className={classes.button_layout}>

            <Button onClick={signUpWithEmail} className={classes.social__icon__button}>
              Sign Up
            </Button>
          </div>
          <p className={classes.reset__psw} onClick={signInWithEmail}> Have an account? Sign In</p>

//            */
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default IsLoadingHOC(Login, "Loading...");
